import { render, staticRenderFns } from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=template&id=9d054638&"
import script from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js&"
export * from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports